import { CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Input, message, Space, Table, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { getProductVidName, productVids } from "../../extensions/helper";
import "./sale-add.css";
import SaleAddItem from "./sale-add-item";
import { ftmPrice } from "../../extensions/utils";
import { dictsGetUsers } from "../../extensions/dicts";
import { isMobile } from "../../extensions/design";
const { Text } = Typography;

const SaleAdd = ({ onClose, clientId, visitId, activeBtns }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVid, setSelectedVid] = useState(0);
  const [search, setSearch] = useState();
  const [sales, setSales] = useState([]);
  const onCancel = () => onClose();
  const [users, setUsers] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const getData = () => {
    setLoading(true);
    serverFetch("product")
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => {
    getData();
    dictsGetUsers(setUsers);
  }, [])

  const columns = [
    { dataIndex: "name", title: "Наименование", width: 250, },
    { dataIndex: "expUnit", title: "Ед.", width: 80, },
    { dataIndex: "expPrice", title: "Цена", align: "right", width: 80 },
    { dataIndex: "vid", title: "Вид", render: value => <div>{getProductVidName(value)}</div> },
    { dataIndex: "storeQty", title: "Ост.", align: "right", width: 80 },
  ]

  const allButtons = [...productVids, { value: -1, label: "Все" }];
  const allowedLabels = activeBtns || allButtons.map(b => b.label);
  const firstEnabledValue = allButtons.find(b => allowedLabels.includes(b.label))?.value ?? 0;

  const toolButtons = allButtons.map(i => (
    <Button key={i.value} 
      className={selectedVid === i.value ? "sport-btn-selected" : ""}
      disabled={!allowedLabels.includes(i.label)} 
      onClick={() => setSelectedVid(i.value)} >{i.label}</Button> 
  ));

  useEffect(() => {
    const currentLabel = allButtons.find(b => b.value === selectedVid)?.label;
    if (!allowedLabels.includes(currentLabel)) {
      setSelectedVid(firstEnabledValue);
    }
  }, [selectedVid, activeBtns]);

  const filteredItems = items.filter(i => {
    if (selectedVid !== -1 && selectedVid !== i.vid)
      return false;
    if (search && i.name.toUpperCase().indexOf(search.toUpperCase()) === -1)
      return false;
    return i.active;
  });

  const onAddInSales = record => {
    setSales([...sales, 
      { productName: record.name, qty: 1, clientId, visitId, productId: record.id, price: record.expPrice, deleted: false, status: 0,
        syma: record.expPrice, expUnit: record.expUnit, discountPrc: 0, storeQty: record.storeQty, vid: record.vid }])
  }

  const onSave = () => {
    const normalizedSales = sales.map((s) => {
      const price = Number.parseFloat(s.price);
      const qty = Number.parseFloat(s.qty);
      const discountPrc = Number.parseFloat(s.discountPrc);
      return {
        ...s,
        price: Number.isFinite(price) ? price : 0,
        qty: Number.isFinite(qty) ? qty : 1,
        discountPrc: Number.isFinite(discountPrc) ? discountPrc : 0,
      };
    });
    setLoading(true);
    serverFetch("sale/List", { method: "POST", bodyData: normalizedSales})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onSaleChange = (newItem, idx) => {
    const newSales = [...sales];
    newSales[idx] = newItem;
    setSales(newSales);
  }

  const isInCart = item =>
    sales.some(s => s.productId === item.id);
  
  const toggleInSales = record => {
    setSales(prev => {
      const exists = prev.some(s => s.productId === record.id);
  
      if (exists) {
        return prev.filter(s => s.productId !== record.id);
      }
  
      return [...prev,
        { productName: record.name, qty: 1, clientId, visitId, productId: record.id, price: record.expPrice, deleted: false,
          status: 0, syma: record.expPrice, expUnit: record.expUnit, discountPrc: 0, storeQty: record.storeQty, vid: record.vid}
      ];
    });
  };
  
  const onSaleDelete = idx => setSales([...sales.slice(0, idx), ...sales.slice(idx + 1)])

  // if (!isMobile) {
  //   return 
  // }

  // if (showCart) {
  //   return (
  //     <div className="sport-modal" style={{ padding: 10 }}>
  //       <SaleMobileCart sales={sales} onChange={onSaleChange} onDelete={onSaleDelete} onClear={() => setSales([])}
  //         onBack={() => setShowCart(false)} users={users} onSave={onSave} loading={loading}/>
  //     </div>
  //   );
  // }

  return isMobile? (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onCancel(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>

          {!showCart && (
            <>
              <div className="sport-modal-title">
                <span>Продажа</span>
                <CloseOutlined className="sport-section-title-close" onClick={onCancel} />
              </div>

              <div className="sport-section" style={{ marginBottom: 12 }}>
              <Space>
                  <Select className="client-abon-form-item" value={selectedVid} onChange={val => setSelectedVid(val)}
                    options={allButtons
                      .filter(b => allowedLabels.includes(b.label))
                      .map(b => ({ value: b.value, label: b.label }))}
                  />
                  <Input className="client-abon-form-item" placeholder="Поиск..." value={search} onChange={e => setSearch(e.target.value)} allowClear/>
                </Space>
              </div>

              <div className="sales-items-list" style={{ overflowY: "scroll", overflowX: "clip"}}>
                {filteredItems.map(item => {
                  const inCart = isInCart(item);

                  return (
                    <div key={item.id} className={`client-item-sale ${inCart ? "in-cart" : ""}`} onClick={() => toggleInSales(item)}>
                      <div className="sale-item-body">
                        <div className="client-item-line-bold-double">
                          <div className="client-item-clip">{item.name}</div>
                          <div className="client-item-clip-right">{item.expPrice}</div>
                        </div>

                        <div className="client-item-abon-card-sum-sale-num-fields">
                          <Text className="client-item-clip">{getProductVidName(item.vid)}</Text>
                          <Text className="client-item-clip">{item.expUnit}</Text>
                          <Text className="client-item-clip">
                          Ост.: {item.storeQty}
                          </Text>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between" }}>
                <Button onClick={() => setSales([])} disabled={sales.length === 0}>Очистить</Button>
                <Button type="primary" onClick={() => setShowCart(true)} disabled={sales.length === 0}>
                  В корзину ({sales.length})
                </Button>
              </div>
            </>
          )}

          {showCart && (<div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={(e) => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Корзина</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => setShowCart(false)} style={{ cursor: "pointer", fontSize: "16px", marginLeft: "auto" }}/>
          </div>
          {sales.length === 0 ? (
            <div style={{ padding: 20, textAlign: "center" }}>Корзина пуста</div>
          ) : (<>
          {sales.map((item, idx) => (
            <SaleAddItem key={idx} item={item} idx={idx} onChange={onSaleChange} onDelete={onSaleDelete} users={users}/>)
          )}
          </>)}
          <div className="client-item-line-double-halfed">
            <Button onClick={() => setSales([])}>Очистить</Button>
            <Button disabled={sales.length <= 0 } onClick={onSave}>Сохранить</Button>
          </div>
        </div>
      </div>
    </div>)}
    </div>
    </div>
    </div>
  ) : (<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" style={{width: 800}} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title"><span>Продажа</span><CloseCircleOutlined className="sport-section-title-close" onClick={onCancel}/></div>
        <div className="sport-section">
          <div className="sport-section-row"><b>Выбор товара/услуги</b></div>
          <Space><Input placeholder="Поиск..." value={search} onChange={e => setSearch(e.target.value)} />{toolButtons}</Space>
          <Table loading={loading} dataSource={filteredItems} columns={columns} size="small" pagination={false} 
            onRow={(record) => ({onClick: () => onAddInSales(record)})} scroll={{y: 400}} rowKey="id"/>
        </div>
        {sales.length ? <div className="sport-section">
          <div className="sport-section-row"><b>Корзина</b></div>
          <SaleAddItem />
          {sales.map((item, idx) => <SaleAddItem item={item} idx={idx} key={idx} onChange={onSaleChange} onDelete={onSaleDelete} users={users} /> )}
          <div className="sale-add-item-line sale-add-item-header">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div>ИТОГО</div>
            <div className="ta-right">{ftmPrice(sales.reduce((prev, i) => prev + i.syma, 0))}</div>
          </div>
          <div className="sale-add-buttons">
            <Button onClick={() => setSales([])}>Очистить</Button>
            <Button disabled={sales.length <= 0 } onClick={onSave}>Сохранить</Button>
            <Button onClick={() => onClose(false)}>Закрыть</Button>
          </div>
        </div> : null}
      </div>
    </div>
  </div>);
}

export default SaleAdd;